import React from 'react';
import { Input } from '../Input';

interface DateInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  controlClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
}

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>((props, ref) => (
  <Input
    ref={ref}
    type="date"
    {...props}
  />
));

DateInput.displayName = 'DateInput';

export { DateInput };
